import React, { useEffect } from 'react';
import './styles.scss';
import { select } from '../../../../../stores';
import { getToken } from '../../../../../selectors/authSelectors';
import { getValidToken, isApp } from '../../../../../utils/index';
import { handleGaError } from '../../../../../utils/generalGaEventAnalytics';
import { gaBannerClick } from '../../../../../../src/modules/offers/utils/prismicBannerUtils';
import { useSelector } from 'react-redux';
import { getCmsProfile } from '../../../../../../src/selectors/userSelectors';
function onClickToGatc(props: any) {
  //ga#DAY16
  try {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    const categoryLabel = (props && props.categoryLabel) || '';
    const title = (props && props.title) || '';
    const id = (props && props.newsId) || '';
    tcWindow.dataLayer.push({
      event: 'healthNews',
      articleCategory: categoryLabel,
      articleID: id,
      articleName: title,
      userId: aToken,
    });

    // HKEMMA-100917 - GA3 Decommission - Remove GA3
    // if (!isApp()) {
    //   tcWindow.tC.event.healthNews(tcWindow, {
    //     articleCategory: categoryLabel,
    //     articleID: id,
    //     articleName: title,
    //     AXAID: aToken,
    //   });
    // }
  } catch (e) {
    handleGaError(e);
  }
}

export const NewsButton = (props: {
  title: string;
  category: string;
  categoryLabel: string;
  thumbnail: string;
  deepLink: string;
  v2?: boolean;
  newsId?: string;
}) => {
  const { title, category, thumbnail, deepLink, categoryLabel, v2 } = props;
  const thumbnailClassName = `news__thumbnail${v2 ? ' web_v2' : ''}`;
  const cmsProfiles = useSelector(getCmsProfile) || ['CWP'];

  useEffect(() => {
    gaBannerClick(cmsProfiles, props?.title, 'display');
  }, []);

  return (
    <div
      className="news__container"
      onClick={() => {
        gaBannerClick(cmsProfiles, props?.title, 'click');
        onClickToGatc(props);
      }}
      data-enable-ga
      data-ga-type="link"
    >
      <a href={deepLink} target="_blank" rel="noreferrer">
        <div
          className={thumbnailClassName}
          style={{ backgroundImage: `url(${thumbnail})` }}
        >
          {categoryLabel ? (
            <div className={`news__category news__category__${category}`}>
              {categoryLabel}
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="news__title">{title}</div>
      </a>
    </div>
  );
};
